export default __webpack_public_path__ + "static/media/play_button.fa025ae6.svg";